import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Define supported languages here - add new languages to this array
const SUPPORTED_LANGUAGES = ['en', 'es'];

// Helper function to load resources for a specific language
const loadLanguageResources = (language) => {
  try {
    // Dynamically require all JSON files for this language
    const context = require.context('./locales', true, /\.json$/);
    const resources = {};
    
    context.keys().forEach((key) => {
      // Check if this file belongs to the current language
      // Example key: './en/common.json' or './es/welcome.json'
      const matches = key.match(/\.\/([^/]+)\/(.+)\.json$/);
      
      if (matches && matches[1] === language) {
        const namespaceName = matches[2]; // Extract namespace (e.g., 'common', 'welcome')
        resources[namespaceName] = context(key);
      }
    });
    
    return resources;
  } catch (error) {
    console.warn(`Could not load resources for language: ${language}`, error);
    return {};
  }
};

// Load resources for all supported languages
const resources = {};
SUPPORTED_LANGUAGES.forEach((lang) => {
  resources[lang] = loadLanguageResources(lang);
});

// Extract all namespace names from the first available language
const namespaces = Object.keys(resources[SUPPORTED_LANGUAGES[0]] || {});

i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en", // default language
    debug: false, // disable for production
    ns: namespaces, // Automatically use all available namespaces
    defaultNS: "common", // Default namespace
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

export default i18n;
